<div class="modal-header border-0 pb-0">
  <div class="data-item d-flex align-items-center gap-3">
    <div class="data-icon bg-primary bg-opacity-10">
      <i class="fas fa-calendar-days text-primary"></i>
    </div>
    <h5 class="modal-title mb-0">
      {{ draft.id !== null ? ('editProgramTitle' | translate:{ number: draft.id }) : ('newProgramTitle' | translate) }}
    </h5>
  </div>
  <button type="button" class="btn-close" [attr.aria-label]="'close' | translate" (click)="cancel()"></button>
</div>

<div class="modal-body pt-2">
  <div class="row g-3">
    <!-- Datos generales -->
    <div class="col-lg-6 d-flex">
      <div class="border rounded-3 p-3 bg-white shadow-sm w-100">
        <h6 class=" mb-3">
          <i class="fas fa-info-circle  me-2"></i>{{ 'general_settings' | translate }}
        </h6>
        <label class="form-label small mb-1" for="lumScheduleName">{{ 'name' | translate }}</label>
        <input
          type="text"
          class="form-control mb-3"
          id="lumScheduleName"
          name="lumScheduleName"
          [(ngModel)]="draft.name"
          [placeholder]="'programs' | translate">

        <div class="d-flex align-items-end justify-content-between gap-3 flex-wrap">
          <div>
            <label class="form-label small mb-1">{{ 'period' | translate }}</label>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <button
                type="button"
                class="btn btn-sm rounded-pill px-3"
                [ngClass]="isGeneralPeriod() ? 'bg-primary text-white border-primary' : 'btn-outline-secondary'"
                [attr.title]="'lumPeriodNoneHint' | translate"
                (click)="setGeneralPeriod()">
                {{ 'general' | translate }}
              </button>
              <button
                *ngFor="let periodId of selectablePeriods"
                type="button"
                class="btn btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                style="width: 2.25rem; height: 2.25rem;"
                [ngClass]="isPeriodSelected(periodId) ? getPeriodSelectedButtonClass(periodId) : 'btn-outline-secondary'"
                [attr.title]="('holidayPeriod' | translate) + ' ' + periodId"
                (click)="togglePeriod(periodId)">
                <span class="fw-semibold small">{{ periodId + 1}}</span>
              </button>
            </div>
            <div class="form-text small text-muted mb-0 mt-1">{{ 'lumPeriodSelectHint' | translate }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 mb-1">
            <label class="switch mb-0">
              <input type="checkbox" id="lumScheduleEnabled" name="lumScheduleEnabled" [(ngModel)]="draft.enabled">
              <span class="slider round"></span>
            </label>
            <label class="mb-0" for="lumScheduleEnabled">{{ 'enabled' | translate }}</label>
          </div>
        </div>
      </div>
    </div>

    <!-- Modo -->
    <div class="col-lg-6 d-flex">
      <div class="border rounded-3 p-3 bg-white shadow-sm w-100">
        <h6 class="mb-3">
          <i class="fas fa-cog text-primary me-2"></i>{{ 'mode' | translate }}
        </h6>
        <div class="btn-group w-100 mb-0" role="group">
          <button
            *ngFor="let option of modeOptions"
            type="button"
            class="btn btn-outline-primary btn-sm"
            [ngClass]="{'bg-primary text-white': draft.mode === option.value}"
            (click)="draft.mode = option.value">
            <i [class]="option.icon + ' me-1'"></i>
            {{ option.labelKey | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Inicio -->
    <div class="col-12">
      <div class="border rounded-3 p-3 bg-white shadow-sm">
        <h6 class="mb-3">
          <i class="fas fa-play-circle text-primary me-2"></i>{{ 'holidayStart' | translate }}
        </h6>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label small mb-1">{{ 'time' | translate }}</label>
            <div class="btn-group w-100 mb-3" role="group">
              <button
                *ngFor="let option of startTypeOptions"
                type="button"
                class="btn btn-outline-primary btn-sm"
                [ngClass]="{'bg-primary text-white': draft.start.type === option.value}"
                (click)="setStartType(option.value)">
                <i [class]="option.icon + ' me-1'"></i>
                {{ option.labelKey | translate }}
              </button>
            </div>

            <ng-container *ngIf="draft.start.type === 'fixed'; else astroStartFields">
              <label class="form-label small mb-1" for="lumStartTime">{{ 'fixedTime' | translate }}</label>
              <input type="time" class="form-control form-control-sm" id="lumStartTime" name="lumStartTime" [(ngModel)]="draft.start.timeStr">
            </ng-container>

            <ng-template #astroStartFields>
              <div class="d-flex align-items-center gap-3">
                <div class="input-group input-group-sm ">
                  <span class="input-group-text">
                    <i [class]="draft.start.type === 'orto' ? 'fas fa-sun text-warning' : 'fas fa-moon text-secondary'"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control bg-light text-primary"
                    readonly
                    tabindex="-1"
                    [value]="getAstroTimePreview(draft.start.type)">
                </div>
                <div class="input-group input-group-sm ">
                  <select
                    class="form-select flex-shrink-0"
                    name="lumStartOffsetSign"
                    [(ngModel)]="draft.start.offsetSign">
                    <option [ngValue]="'+'">+</option>
                    <option [ngValue]="'-'">-</option>
                  </select>
                  <input
                    type="time"
                    class="form-control flex-fill"
                    name="lumStartOffsetTime"
                    [(ngModel)]="draft.start.offsetTime">
                </div>
              </div>
              <div class="form-text small mt-2 mb-0" *ngIf="draft.start.offsetTime !== '00:00'">
                {{ getAstroTimePreview(draft.start.type) }}
                <i class="fas fa-arrow-right mx-1"></i>
                <span class="text-primary">{{ getAstroAdjustedTime(draft.start.type, draft.start.offsetTime, draft.start.offsetSign) }}</span>
              </div>
            </ng-template>
          </div>

          <div class="col-md-6">
            <label class="form-label small mb-1">{{ 'lumRelayState' | translate }}</label>
            <div class="btn-group w-100" role="group" [attr.aria-label]="'lumRelayState' | translate">
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                [ngClass]="{'bg-primary text-white': draft.relayAction === 'on'}"
                (click)="draft.relayAction = 'on'">
                {{ 'on' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                [ngClass]="{'bg-primary text-white': draft.relayAction === 'off'}"
                (click)="draft.relayAction = 'off'">
                {{ 'off' | translate }}
              </button>
            </div>
            <div class="d-flex justify-content-center mt-2">
              <svg
                viewBox="0 0 24 24"
                width="48"
                height="48"
                class="text-secondary"
                [attr.title]="(draft.relayAction === 'on' ? 'lumRelayClosed' : 'lumRelayOpen') | translate"
                [attr.aria-label]="(draft.relayAction === 'on' ? 'lumRelayClosed' : 'lumRelayOpen') | translate">
                <path
                  [attr.d]="getRelaySwitchPath(draft.relayAction)"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fin (cíclico) -->
    <div class="col-12" *ngIf="draft.mode === 'cyclic'">
      <div class="border rounded-3 p-3 bg-white shadow-sm">
        <h6 class=" mb-3">
          <i class="fas fa-stop-circle text-primary me-2"></i>{{ 'endTime' | translate }}
        </h6>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label small mb-1">{{ 'time' | translate }}</label>
            <div class="btn-group w-100 mb-3" role="group">
              <button
                *ngFor="let option of startTypeOptions"
                type="button"
                class="btn btn-outline-primary btn-sm"
                [ngClass]="{'bg-primary text-white': draft.end.type === option.value}"
                (click)="setEndType(option.value)">
                <i [class]="option.icon + ' me-1'"></i>
                {{ option.labelKey | translate }}
              </button>
            </div>

            <ng-container *ngIf="draft.end.type === 'fixed'; else astroEndFields">
              <label class="form-label small mb-1" for="lumEndTime">{{ 'fixedTime' | translate }}</label>
              <input type="time" class="form-control form-control-sm" id="lumEndTime" name="lumEndTime" [(ngModel)]="draft.end.timeStr">
            </ng-container>

            <ng-template #astroEndFields>
              <div class="d-flex align-items-center gap-3">
                <div class="input-group input-group-sm ">
                  <span class="input-group-text">
                    <i [class]="draft.end.type === 'orto' ? 'fas fa-sun text-warning' : 'fas fa-moon text-secondary'"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control bg-light text-primary"
                    readonly
                    tabindex="-1"
                    [value]="getAstroTimePreview(draft.end.type)">
                </div>
                <div class="input-group input-group-sm ">
                  <select
                    class="form-select flex-shrink-0"
                    style="max-width: 20px;"
                    name="lumEndOffsetSign"
                    [(ngModel)]="draft.end.offsetSign">
                    <option [ngValue]="'+'">+</option>
                    <option [ngValue]="'-'">-</option>
                  </select>
                  <input
                    type="time"
                    class="form-control flex-fill"
                    name="lumEndOffsetTime"
                    [(ngModel)]="draft.end.offsetTime">
                </div>
              </div>
              <div class="form-text small mt-2 mb-0" *ngIf="draft.end.offsetTime !== '00:00'">
                {{ getAstroTimePreview(draft.end.type) }}
                <i class="fas fa-arrow-right mx-1"></i>
                <span class="text-primary">{{ getAstroAdjustedTime(draft.end.type, draft.end.offsetTime, draft.end.offsetSign) }}</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <!-- Días -->
    <div class="col-12">
      <div class="border rounded-3 p-3 bg-white shadow-sm">
        <h6 class="mb-3 text-center">
          <i class="fas fa-calendar-week text-primary me-2"></i>{{ 'weekDays' | translate }}
        </h6>

        <div class="d-flex justify-content-center mb-3">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              [ngClass]="{'bg-primary text-white': isWeekdayPreset('weekdays')}"
              (click)="setWeekdayPreset('weekdays')">
              {{ 'workdays' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              [ngClass]="{'bg-primary text-white': isWeekdayPreset('weekend')}"
              (click)="setWeekdayPreset('weekend')">
              {{ 'weekend' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-outline-primary btn-sm"
              [ngClass]="{'bg-primary text-white': isWeekdayPreset('allDays')}"
              (click)="setWeekdayPreset('allDays')">
              {{ 'allDays' | translate }}
            </button>
          </div>
        </div>

        <div class="d-flex flex-wrap justify-content-center gap-2">
          <button
            *ngFor="let day of daysOfWeek"
            type="button"
            class="btn btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
            style="width: 2.25rem; height: 2.25rem;"
            [ngClass]="isWeekdaySelected(day.value) ? 'bg-primary text-white border-primary' : 'btn-outline-secondary'"
            [attr.title]="day.key | translate"
            (click)="toggleWeekday(day.value)">
            <span class="small">{{ day.short }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer border-0 pt-0">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
    {{ 'cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="save()" [disabled]="!draft.name?.trim()?.length">
    {{ 'save' | translate }}
  </button>
</div>
